import { render, staticRenderFns } from "./ProfitModal.vue?vue&type=template&id=3e84feee&scoped=true&"
import script from "./ProfitModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProfitModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProfitModal.vue?vue&type=style&index=0&id=3e84feee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e84feee",
  null
  
)

export default component.exports